import React, { useState} from "react";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import addHours from 'date-fns/addHours'
import addMinutes from 'date-fns/addMinutes'

export const TimeSelect = props => {

    const { id, label, labelStyle, value, onChange, style, earliest, latest, interval, TimeList, bookingDate} = props;
    const labelId = id + '-label';
    const [internal, setInternal] = useState(value.toLocaleTimeString('en-GB') );

    let validTimes = TimeList != null && TimeList.length > 0 ? TimeList : []

    if (TimeList == null || TimeList.length === 0) {
        let start = new Date(bookingDate);
        start = addHours(start, earliest.split(":")[0]);
        start = addMinutes(start, earliest.split(":")[1]);

        let end = new Date(bookingDate);
        end = addHours(end, latest.split(":")[0]);
        end = addMinutes(end, latest.split(":")[1]);


        let offset = new Date(bookingDate).getTimezoneOffset();
        if (offset !== 0) {
            start = addMinutes(start, offset);
            end = addMinutes(end, offset);
        }

        let next = start

        while (next <= end) {
            validTimes.push({label: next.toLocaleTimeString('en-GB') , value: next});
            next = addMinutes(next, interval);
        }
        
    }

    const handleChange = (event) => {
        setInternal(event.target.value);
        const selectedItem = validTimes.find(item => item.label === event.target.value);
        onChange(selectedItem.value);
    }
    //let selectedValue = bookingDate;
    //if (value != null) {
    //    selectedValue = addHours(selectedValue, value.split(":")[0]);
    //    selectedValue = addMinutes(selectedValue, value.split(":")[1]);
    //}
    

    return (<React.Fragment>
        <InputLabel
            id={labelId}
            style={labelStyle}
        >
            {label}
        </InputLabel>
        <Select
            labelId={labelId}
            id={id}
            value={internal}
            onChange={handleChange}
            style={style}
        >
            {validTimes.map((item, index) => {
                return (
                    <MenuItem key={index} value={item.label}>
                        {item.label.split(":")[0]}:{item.label.split(":")[1]}
                    </MenuItem>
                );
            })}
        </Select>
    </React.Fragment>)
}